import './styles/globals.css'
// styles
import 'react-toastify/dist/ReactToastify.css'

import { keycloak } from 'constants/keycloak-instance'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify'
import biAxiosInstance from 'shared/api/bi/axiosInstance'
import callAxiosInstance from 'shared/api/call/axiosInstance'
import crmAxiosInstance from 'shared/api/crm/axiosInstance'
import homeAxiosInstance from 'shared/api/home/axiosInstance'
import managerAxiosInstance from 'shared/api/manager/axiosInstance'
import KeyCloakAuthWrapper from 'shared/components/auth/KeyCloakAuthWrapper'
import AxiosInstanceTokenInjector from 'shared/components/auth/KeyCloakAuthWrapper/AxiosInstanceTokenInjector'
import { SOCKET_URL } from 'shared/constants/defaultENV'
import {
  LoadingLoggedIdUser,
  LoggedInUserContextProvider,
} from 'shared/contexts/useLoggedInUser'

import CallDetail from './pop-up/CallDetail'
import SocketProvider from './shared/contexts/socket/socket-context'
import store from './store/store'

const tag = document.createElement('div')
document.body.appendChild(tag)
tag.id = 'AMIR_AMIR_AMIR_YAZID_YAZID_YAZID'

if (process.env.NODE_ENV === 'development') {
  window.Keycloak = keycloak as any
}

const axiosInjectors = (
  <AxiosInstanceTokenInjector
    axiosInstances={[
      crmAxiosInstance,
      callAxiosInstance,
      managerAxiosInstance,
      biAxiosInstance,
      homeAxiosInstance,
    ]}
  />
)

ReactDOM.render(
  <Provider store={store}>
    <ToastContainer
      autoClose={2000}
      rtl
      transition={Slide}
      position={'top-center'}
      toastClassName="text-sm"
      toastStyle={{
        fontFamily: 'dana, Nova, system-ui, sans-serif',
        boxShadow:
          'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px',
      }}
    />
    <BrowserRouter>
      {process.env.NODE_ENV === 'development' ? (
        <>
          <button
            onClick={() => {
              // @ts-ignore
              window.Keycloak?.logout()
            }}
          >
            logout
          </button>
          <KeyCloakAuthWrapper instance={keycloak}>
            {axiosInjectors}
            <SocketProvider socketUrl={SOCKET_URL}>
              <LoggedInUserContextProvider>
                <LoadingLoggedIdUser>
                  <CallDetail />
                </LoadingLoggedIdUser>
              </LoggedInUserContextProvider>
            </SocketProvider>
          </KeyCloakAuthWrapper>
        </>
      ) : (
        <SocketProvider socketUrl={SOCKET_URL}>
          {axiosInjectors}
          <LoggedInUserContextProvider>
            <LoadingLoggedIdUser showLoading={false}>
              <CallDetail />
            </LoadingLoggedIdUser>
          </LoggedInUserContextProvider>
        </SocketProvider>
      )}
    </BrowserRouter>
  </Provider>,
  tag
)
